import { EDropzoneFileErrorCodes } from '@enums/dropzone';

export const fileErrors = {
	[EDropzoneFileErrorCodes.fileInvalidType]: 'Allowed extensions are png, svg, jpg, jpeg',
	[EDropzoneFileErrorCodes.fileTooLarge]: 'File size is not allowed. Maximum is 1 Mb',
	[EDropzoneFileErrorCodes.tooManyFiles]: 'Only one file can be uploaded',
};
